import { css } from '@emotion/react'

type Props = {
  onClickOutside?: () => void
  dim?: boolean
}

export default function ClickOutsideLayer(props: Props) {
  const onClick = (e: React.MouseEvent | React.TouchEvent) => {
    e.preventDefault()
    e.stopPropagation()

    props.onClickOutside && props.onClickOutside()
  }
  return (
    <div
      css={[
        css`
          position: fixed;
          top: 0;
          right: 0;
          bottom: 0;
          left: 0;
          background: transparent;
          cursor: default;
          transition: background-color 0.2s;
        `,
        props.dim &&
          css`
            background: rgba(0, 0, 0, 0.35);
            animation: fade-in 0.2s ease-out;
          `,
      ]}
      onClick={onClick}
      onContextMenu={onClick}
      onTouchStart={onClick}
      onMouseDown={onClick}
    />
  )
}
